import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';

import { DashboardsAbstract } from '@dashboards/components/abstract/dashboards.abstract';

@Component({
  selector: 'app-dashboard-container',
  templateUrl: './dashboard-container.component.html',
  styleUrls: ['./dashboard-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardContainerComponent extends DashboardsAbstract {
  loading = true;
  emptyDashboard = false;

  @Input() containerCss = '';
  @Input() bodyCss = '';
  @Input() stickyFooter = false;
  @Input() customEmptyDashboardTemplate: TemplateRef<any>;

  @Input() set isLoading(isLoading: boolean) {
    this.loading = isLoading === undefined ? true : isLoading;
    this.cdr.detectChanges();
  }

  @Input() set isEmptyDashboard(isEmptyDashboard: boolean) {
    this.emptyDashboard = isEmptyDashboard === undefined ? false : isEmptyDashboard;
    this.cdr.detectChanges();
  }

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onScroll = new EventEmitter<{ position: number }>();

  constructor(protected cdr: ChangeDetectorRef) {
    super(cdr);
  }

  onBodyScroll($event) {
    this.onScroll.emit({ position: $event.target.scrollTop });
  }
}
